export const REPS = {
  opsRepEditable: {
    key: 'ops_rep_id',
    name: 'ops_rep_name',
    id: 'opsRepEditable',
    label: 'Ops Rep',
    type: 'transfix_admin',
  },
  complianceRepEditable: {
    key: 'compliance_rep',
    name: 'full_name',
    id: 'complianceRepEditable',
    label: 'Compliance Rep',
    type: 'transfix_admin',
  },
}
